import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import textData from '../../utils/langText'
import { Outlet } from 'react-router-dom'

const HomeLayout = ({changeLang}) => {
  return (
    <>
      <Header textData={textData} changeLang={changeLang} />
        <Outlet />
      <Footer textData={textData} changeLang={changeLang} />
    </>
  )
}

export default HomeLayout
